function degreesToRadians(degrees) {
  let pi = Math.PI;
  return degrees * (pi / 180);
}

function getFullBox(onlyVisible) {
  let min = { x: 100000, y: 100000, z: 100000 };
  let max = { x: -10000, y: -100000, z: -100000 };
  let fullBox = { min, max };
  vueApp.allItems.forEach(function (model) {
    if (onlyVisible && !model.isVisible) {
      return;
    }
    let itemBox = model.defaultBox;
    if (!itemBox) {
      let mesh = viewer.get_model_mesh(model.id);
      let geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      itemBox = model.defaultBox = geometry.boundingBox;
    }

    if (itemBox.min.x < fullBox.min.x) {
      fullBox.min.x = itemBox.min.x;
    }
    if (itemBox.min.y < fullBox.min.y) {
      fullBox.min.y = itemBox.min.y;
    }
    if (itemBox.min.z < fullBox.min.z) {
      fullBox.min.z = itemBox.min.z;
    }
    if (itemBox.max.x > fullBox.max.x) {
      fullBox.max.x = itemBox.max.x;
    }
    if (itemBox.max.y > fullBox.max.y) {
      fullBox.max.y = itemBox.max.y;
    }
    if (itemBox.max.z > fullBox.max.z) {
      fullBox.max.z = itemBox.max.z;
    }
  });
  fullBox = offsetBox(fullBox, 0, 0, 0, 0);
  return fullBox;
}

function getTeethBox(isMaxilla, hideOpposite) {
//   console.log("getTeethBox", isMaxilla, hideOpposite);
  let min = { x: 100000, y: 100000, z: 100000 };
  let max = { x: -10000, y: -100000, z: -100000 };
  let teethBox = { min, max };
  vueApp.allItems.forEach(function (model) {
    if (
      model.isTooth &&
      (typeof isMaxilla !== "boolean" || model.isMaxilla == isMaxilla)
    ) {
      if (hideOpposite && model.isVisible) {
        viewer.set_color(model.id, model.color);
      }
      let mesh = viewer.get_model_mesh(model.id);
      //   let geometry = mesh.geometry.clone();
      //   geometry.applyMatrix4(mesh.matrix);
      let geometry = mesh.geometry;
      if (!geometry.boundingBox) geometry.computeBoundingBox();

      let toothBox = geometry.boundingBox;
      toothBox = offsetBox(
        toothBox,
        mesh.position.x,
        mesh.position.y,
        mesh.position.z
      );

      if (toothBox.min.x < teethBox.min.x) {
        teethBox.min.x = toothBox.min.x;
      }
      if (toothBox.min.y < teethBox.min.y) {
        teethBox.min.y = toothBox.min.y;
      }
      if (toothBox.min.z < teethBox.min.z) {
        teethBox.min.z = toothBox.min.z;
      }
      if (toothBox.max.x > teethBox.max.x) {
        teethBox.max.x = toothBox.max.x;
      }
      if (toothBox.max.y > teethBox.max.y) {
        teethBox.max.y = toothBox.max.y;
      }
      if (toothBox.max.z > teethBox.max.z) {
        teethBox.max.z = toothBox.max.z;
      }
      //drawBox(toothBox);
    } else if (typeof isMaxilla === "boolean" && hideOpposite) {
      viewer.set_color(model.id, "transparent");
    }
  });
  teethBox = offsetBox(teethBox, 0, 0, 0, 0);
  //drawBox(teethBox);
  return teethBox;
}

function getTeethZoom(teethBox) {
  let padding = 0;
  let w = (teethBox.size.x + padding) / 2;
  let h = (teethBox.size.y + padding) / 2;
  let fovX = viewer.camera.fov * viewer.camera.aspect;
  let fovY = viewer.camera.fov;

  let distanceX = w / Math.tan((Math.PI * fovX) / 360) + w;
  let distanceY = h / Math.tan((Math.PI * fovY) / 360) + w;

  let defaultZoom = Math.max(distanceX, distanceY);
  return defaultZoom;
}

function switchToMandibular(notHide) {
  // vueApp.leaveModes();
  let teethBox = getTeethBox(false, !notHide);
  let teethZoom = getTeethZoom(teethBox);
  //resetCameraUp();
  viewer.camera.position.x = teethBox.center.x;
  viewer.camera.position.y = teethBox.center.y + teethZoom;
  viewer.camera.position.z = teethBox.center.z;
  if (viewer.controls_type == 1) {
    viewer.camera.up.y = 0;
    viewer.camera.up.x = 0;
    viewer.camera.up.z = -1;
  }
  vueApp.lookAtPoint(teethBox.center);
  //vueApp.isOcclusal = true;
}

function switchToMaxilla(notHide) {
  //vueApp.leaveModes();
  let teethBox = getTeethBox(true, !notHide);
  let teethZoom = getTeethZoom(teethBox);
  //resetCameraUp();
  viewer.camera.position.x = teethBox.center.x;
  viewer.camera.position.y = teethBox.center.y - teethZoom;
  viewer.camera.position.z = teethBox.center.z;
  if (viewer.controls_type == 1) {
    viewer.camera.up.y = 0;
    viewer.camera.up.x = 0;
    viewer.camera.up.z = 1;
  }
  vueApp.lookAtPoint(teethBox.center);
  //vueApp.isOcclusal = true;
}

export {
  degreesToRadians,
  getTeethBox,
  getFullBox,
  getTeethZoom,
  switchToMaxilla,
  switchToMandibular,
};
